export const SIZE = {
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const STATE = {
    hover: 'hover',
    focus: 'focus',
};
